import { isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { getCardById } from '../../use';
import { wait } from '@/_core/utils/misc';

const { registerReducer } = useStorymapStore();

export class SetKeyOnNewCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetKeyOnNewCard';

    public constructor(public cardId: string, public key: string) {
        super(SetKeyOnNewCard.ACTION_TYPE);
    }
}

const reducer = async (state: StorymapState, action: SetKeyOnNewCard): Promise<void> => {
    const card = await getCard(action.cardId, () => isActionCurrent(action));

    if (card != null && isActionCurrent(action)) {
        card.key = action.key;
    }
};

const getCard = async (cardId: string, isCurrent: () => boolean) => {
    let card = null;
    let counter = 0;

    do {
        if (!isCurrent()) return null;
        card = getCardById(cardId);
        counter++;

        if (card == null) {
            await wait(500);
        }
    } while (card == null && counter < 10);

    return card;
}

//@ts-ignore
registerReducer(SetKeyOnNewCard.ACTION_TYPE, reducer);